<template>
  <div id="itembank-form">
    <!-- begin breadcrumb -->
    <ol class="breadcrumb pull-right">
      <li><router-link :to="{path: '/'}">Home</router-link></li>
      <li>Bank Soal</li>
      <li><router-link :to="{path: '/items', query: {mapel: $route.query.mapel}}">{{ mapel }}</router-link></li>
      <li class="active">Create</li>
    </ol>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">Buat Soal Baru</h1>
    <!-- end page-header -->
    <div class="row">
      <div class="col-md-12">
        <div class="panel panel-inverse">
          <div class="panel-heading">
            <div class="btn-group pull-right">
              <button type="button" class="btn btn-success btn-xs" @click="save()">Simpan</button>
            </div>
            <h4 class="panel-title">{{ mapel }}</h4>
          </div>
          <div class="panel-body panel-form">
            <form class="form-horizontal form-bordered">
              <div class="form-group" v-bind:class="{ 'has-error': errors.indexOf('jenjang') >= 0 }">
                <label class="col-md-2 control-label">Jenjang *</label>
                <div class="col-md-8 col-xs-12">
                  <span class="help-block" v-if="errors.indexOf('jenis') >= 0">field ini wajib diisi</span>
                  <select class="form-control" v-model="form.jenjang" @change="resetGrades()">
                    <option v-bind:key="level.id" v-for="level in levels" :value="level.id">
                      {{ level.nama }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="form-group" v-bind:class="{ 'has-error': errors.indexOf('grades') >= 0 }">
                <label class="col-md-2 control-label">Kelas *</label>
                <div class="col-md-8 col-xs-12">
                  <span class="help-block" v-if="errors.indexOf('grades') >= 0">field ini wajib diisi</span>
                  <div v-if="form.jenjang === 3">
                    <input type="checkbox" class="checkbox m-r-5" :value="10" v-model="grades"><span class="f-s-14 f-w-700 m-r-10">10</span>
                    <input type="checkbox" class="checkbox m-r-5" :value="11" v-model="grades"><span class="f-s-14 f-w-700 m-r-10">11</span>
                    <input type="checkbox" class="checkbox m-r-5" :value="12" v-model="grades"><span class="f-s-14 f-w-700 m-r-10">12</span>
                  </div>
                  <div v-if="form.jenjang === 2">
                    <input type="checkbox" class="checkbox m-r-5" :value="7" v-model="grades"><span class="f-s-14 f-w-700 m-r-10">7</span>
                    <input type="checkbox" class="checkbox m-r-5" :value="8" v-model="grades"><span class="f-s-14 f-w-700 m-r-10">8</span>
                    <input type="checkbox" class="checkbox m-r-5" :value="9" v-model="grades"><span class="f-s-14 f-w-700 m-r-10">9</span>
                  </div>
                  <div v-if="form.jenjang === 1">
                    <input type="checkbox" class="checkbox m-r-5" :value="4" v-model="grades"><span class="f-s-14 f-w-700 m-r-10">4</span>
                    <input type="checkbox" class="checkbox m-r-5" :value="5" v-model="grades"><span class="f-s-14 f-w-700 m-r-10">5</span>
                    <input type="checkbox" class="checkbox m-r-5" :value="6" v-model="grades"><span class="f-s-14 f-w-700 m-r-10">6</span>
                  </div>
                </div>
              </div>
              <div class="form-group" v-bind:class="{ 'has-error': errors.indexOf('jenis') >= 0 }">
                <label class="col-md-2 control-label">Jenis *</label>
                <div class="col-md-8 col-xs-12">
                  <span class="help-block" v-if="errors.indexOf('jenis') >= 0">field ini wajib diisi</span>
                  <select class="form-control" v-model="form.jenis">
                    <option v-bind:key="type.id" v-for="type in types" :value="type.id">
                      {{ type.nama }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="form-group" v-bind:class="{ 'has-error': errors.indexOf('topic') >= 0 }">
                <label class="col-md-2 control-label">Topik *</label>
                <div class="col-md-8 col-xs-12">
                  <span class="help-block" v-if="errors.indexOf('topic') >= 0">field ini wajib diisi</span>
                  <app-autocomplete placeholder="Cari Bab / (Sub) Sub Bab" :data="topics" v-on:selected="assignTopic($event)" :value="form.topic"></app-autocomplete>
                </div>
              </div>
              <div class="form-group">
                <label class="col-md-2 control-label">Sumber</label>
                <div class="col-md-8 col-xs-12">
                  <input class="form-control" type="text" v-model="form.sumber"/>
                </div>
              </div>
              <div class="form-group">
                <label class="col-md-2 control-label">Label</label>
                <div class="col-md-8 col-xs-12">
                  <input type="text" v-model="form.label" class="form-control" style="text-transform: uppercase" @input="labelQuery = form.label" maxlength="255">
                  <app-labelAutocomplete v-on:selected="onLabelSelected" :query="labelQuery"></app-labelAutocomplete>
                </div>
              </div>
              <div class="form-group">
                <label class="col-md-2 control-label">Bank Soal</label>
                <div class="col-md-8 col-xs-12">
                    <label>
                      <input type="checkbox" v-model="form.is_restricted"/>
                      Tidak dimunculkan
                    </label>
                </div>
              </div>
              <div class="form-group">
                <label class="col-md-2 control-label">Wacana</label>
                <div class="col-md-8 col-xs-12">
                  <app-wacana v-on:selected="form.wacana = $event" :value="form.wacana"></app-wacana>
                </div>
              </div>
              <!-- start of form group -->
              <div class="form-group" v-bind:class="{ 'has-error': errors.indexOf('soal') >= 0 }">
                <label class="col-md-2 control-label">Soal *</label>
                <div class="col-md-8 col-xs-12">
                  <span class="help-block" v-if="errors.indexOf('soal') >= 0">field ini wajib diisi</span>
                  <app-editor :rows="8" v-on:content-updated="form.soal = $event" :value="form.soal" :context="mapel"></app-editor>
                </div>
              </div>
              <!-- end of form group -->
              <div class="form-group">
                <label class="col-md-2 control-label">Opsi *</label>
                <div class="col-md-8 col-xs-12">
                  <div class="input-group" v-bind:class="{ 'has-error': errors.indexOf('opsiA') >= 0 }">
                    <span class="input-group-addon">A</span>
                    <app-editor :rows="2" v-on:content-updated="form.opsiA = $event" :value="form.opsiA" :context="mapel"></app-editor>
                    <span class="help-block" v-if="errors.indexOf('opsiA') >= 0">field ini wajib diisi</span>
                  </div>
                  <p></p>
                  <div class="input-group" v-bind:class="{ 'has-error': errors.indexOf('opsiB') >= 0 }">
                    <span class="input-group-addon">B</span>
                    <app-editor :rows="2" v-on:content-updated="form.opsiB = $event" :value="form.opsiB" :context="mapel"></app-editor>
                    <span class="help-block" v-if="errors.indexOf('opsiB') >= 0">field ini wajib diisi</span>
                  </div>
                  <p></p>
                  <div class="input-group" v-bind:class="{ 'has-error': errors.indexOf('opsiC') >= 0 }">
                    <span class="input-group-addon">C</span>
                    <app-editor :rows="2" v-on:content-updated="form.opsiC = $event" :value="form.opsiC" :context="mapel"></app-editor>
                    <span class="help-block" v-if="errors.indexOf('opsiC') >= 0">field ini wajib diisi</span>
                  </div>
                  <p></p>
                  <div class="input-group" v-bind:class="{ 'has-error': errors.indexOf('opsiD') >= 0 }">
                    <span class="input-group-addon">D</span>
                    <app-editor :rows="2" v-on:content-updated="form.opsiD = $event" :value="form.opsiD" :context="mapel"></app-editor>
                    <span class="help-block" v-if="errors.indexOf('opsiD') >= 0">field ini wajib diisi</span>
                  </div>
                  <hr />
                  <p>Optional:</p>
                  <div class="input-group">
                    <span class="input-group-addon">E</span>
                    <app-editor :rows="2" v-on:content-updated="form.opsiE = $event" :value="form.opsiE" :context="mapel"></app-editor>
                  </div>
                </div>
              </div>
              <div class="form-group" v-bind:class="{ 'has-error': errors.indexOf('jawaban') >= 0 }">
                <label class="col-md-2 control-label">Jawaban *</label>
                <div class="col-md-8 col-xs-12">
                  <span class="help-block" v-if="errors.indexOf('jawaban') >= 0">field ini wajib diisi</span>
                  <select class="form-control" placeholder="A" type="text" v-model="form.jawaban">
                    <option value="A">A</option>
                    <option value="B">B</option>
                    <option value="C">C</option>
                    <option value="D">D</option>
                    <option value="E">E</option>
                  </select>
                </div>
              </div>
              <div class="form-group">
                <label class="col-md-2 control-label">Eigen</label>
                <div class="col-md-8 col-xs-12">
                  <input class="form-control" placeholder="2.55" type="number" step="any" v-model="form.eigen">
                </div>
              </div>
              <div class="form-group">
                <label class="col-md-2 control-label">Pembahasan</label>
                <div class="col-md-8 col-xs-12">
                  <app-editor :rows="8" v-on:content-updated="form.pembahasan = $event" :value="form.pembahasan" :context="mapel"></app-editor>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LabelAutocomplete from '@/components/plugins/LabelAutocomplete'
import Autocomplete from '@/components/plugins/Autocomplete'
import MarkdownEditor from '@/components/plugins/MarkdownEditor'
import Wacana from '@/components/itembank/Wacana'
import itembankService from '@/services/itembank.js'

export default {
  name: 'itembank-form',
  components: {
    'app-labelAutocomplete': LabelAutocomplete,
    'app-autocomplete': Autocomplete,
    'app-editor': MarkdownEditor,
    'app-wacana': Wacana
  },
  data: function() {
    var mapelId = this.$route.query.mapel
    var mapels = JSON.parse(localStorage.getItem('mapels'))
    var found = mapels.find(function(element) {
      return element.id == mapelId
    })

    return {
      compiledContent: '',
      labelQuery: '',
      mapel: found.nama,
      types: [],
      levels: [],
      topics: [],
      errors: [],
      grades: [],
      form: {
        id: 0,
        wacana: null,
        mapelId: this.$route.query.mapel,
        sumber: '',
        topic: '',
        jenjang: 3,
        grades: [],
        jenis: 1,
        babId: 0,
        subBabId: 0,
        subSubBabId: 0,
        soal: '',
        opsiA: '',
        opsiB: '',
        opsiC: '',
        opsiD: '',
        opsiE: '',
        jawaban: '',
        pembahasan: '',
        is_restricted: false,
        label: '',
        eigen: 0.00,
        sumber: '',
        pembahasan: ''
      }
    }
  },
  watch: {
    "grades": function(val) {
      this.form.grades = val
    }
  },
  mounted: function() {
    var context = this
    itembankService.getListOfItemType(function(result) {
      if(result.success) {
        context.types = result.data
      }
    })

    itembankService.getListOfSchoolGrade(function(result) {
      if(result.success) {
        context.levels = result.data
      }
    })

    var mapelId = this.$route.query.mapel
    var mapel = this.getMapelById(mapelId)
    itembankService.getListOfTopic(mapel.code, function(result) {
      context.topics = result.data
    })

    if(this.$route.query.id) {
      this.form.id = this.$route.query.id
      var context = this
      itembankService.getItemById(this.form.id, function(result) {
        if(result.success) {
          var item = result.data
          context.form.jenjang = item.jenjang.id
          context.form.jenis = item.jenis_soal.id
          context.form.sumber = item.sumber
          context.form.soal = item.isi
          context.form.opsiA = item.pilihan_1
          context.form.opsiB = item.pilihan_2
          context.form.opsiC = item.pilihan_3
          context.form.opsiD = item.pilihan_4
          context.form.opsiE = item.pilihan_5
          context.form.jawaban = item.jawaban
          context.form.eigen = item.nilai_eigen
          context.form.pembahasan = item.pembahasan
          context.form.is_restricted = item.is_restricted
          context.form.label = item.label

          item.grades.forEach(function(grade) {
            context.grades.push(grade.grade)
          })

          context.form.grades = context.grades

          if(item.wacana) context.form.wacana = {id: item.wacana.id, content: item.wacana.isi}

          if(item.bab) {
            context.form.babId = item.bab.id
            context.form.topic += item.bab.nama
          }

          if(item.sub_bab) {
            context.form.subBabId = item.sub_bab.id
            context.form.topic += '/ ' + item.sub_bab.nama
          }

          if(item.sub_sub_bab) {
            context.form.subSubBabId = item.sub_sub_bab.id
            context.form.topic += '/ ' + item.sub_sub_bab.nama
          }
        }
      })
    }
  },
  methods: {
    getMapelById: function(mapelId) {
      var mapel = JSON.parse(localStorage.getItem('mapels'));
      var found = mapel.find(function(element) {
        return element.id == mapelId
      })

      return found
    },
    save: function() {
      var context = this
      if(this.validateForm()) {

        if(!this.form.id) {
          itembankService.createItem(this.form, function(result) {
            if(result.success) {
              context.$router.push({path: '/items', query: {mapel: context.$route.query.mapel}})
            }
          })
        } else {
          itembankService.updateItem(this.form.id, this.form, function(result) {
            if(result.success) {
              context.$router.push({path: '/items', query: {mapel: context.$route.query.mapel}})
            }
          })
        }
      }
    },
    validateForm: function() {
      this.errors = []
      if(!this.form.jenjang) this.errors.push('jenjang')
      if(!this.form.jenis) this.errors.push('jenis')
      if(!this.form.babId) this.errors.push('topic')
      if(!this.form.soal) this.errors.push('soal')
      if(!this.form.opsiA) this.errors.push('opsiA')
      if(!this.form.opsiB) this.errors.push('opsiB')
      if(!this.form.opsiC) this.errors.push('opsiC')
      if(!this.form.opsiD) this.errors.push('opsiD')
      if(!this.form.jawaban) this.errors.push('jawaban')
      if(this.grades.length === 0) this.errors.push('grades')

      if(this.errors.length == 0) return true

      return false
    },
    assignTopic: function(result) {
      var topicIds = result.data
      this.form.babId = topicIds[0]
      this.form.subBabId = topicIds[1]
      this.form.subSubBabId = topicIds[2]
    },
    onLabelSelected: function(label) {
      this.form.label = label
      this.labelQuery = ''
    },
    resetGrades: function() {
      this.grades = []
    },
  }
}
</script>



// WEBPACK FOOTER //
// Form.vue?8ee32ad8